import { callAPI } from '../../../shared/helpers'

export const ActionTypes = {
  GET_MANAGERS: 'GET_MANAGERS',
}

export const addManager = (firstName, lastName, email) => (dispatch, getState) => {
  const state = getState()
  const url = state.urls.managers
  const user = { first_name: firstName, last_name: lastName, email: email }
  const requestBody = { user: user, commit: 'Invite', league_id: state.customerLeagueId }
  return callAPI(url, 'POST', requestBody, {}, 'application/json')
    .then(data => dispatch(getManagers()).then(() => data))
}

export const getManagers = () => (dispatch, getState) => {
  const state = getState()
  const url = state.urls.managers
  return callAPI(url, 'GET')
    .then(data => {
      dispatch({
        type: ActionTypes.GET_MANAGERS,
        data: data,
      })
    })
}

export const reinviteManager = (userId) => (dispatch, getState) => {
  const state = getState()
  const url = state.urls.reinviteManager
  const requestBody = { user_id: userId }
  return callAPI(url, 'GET', requestBody)
}

export const deleteManager = (userId) => (dispatch, getState) => {
  const state = getState()
  const url = state.urls.deleteManager
  const requestBody = {user_id: userId, league_id: state.customerLeagueId}
  return callAPI(url, 'GET', requestBody)
    .then(data => dispatch(getManagers()).then(() => data))
}
